

export default {
    install(Vue) {
        Vue.filter('toNum', (val) => val / 1);
    }
}